import { createStore } from 'vuex';
import vuexPersist from 'vuex-persistedstate';

export default createStore({
	state: {
		user: {
			id: null,
			name: '',
			email: '',
			roleId: null,
			role: '',
			currency: '',
			createdBy: '',
			// createdTime: '',
			// createdDate: '',
		},
		titles: {
			titles: []
		},
	},
	mutations: {
		setTitles(state, titles) {
			state.titles = { titles };
		},
		setUser(state, user) {
			state.user.id = user.id;
			state.user.name = user.name;
			state.user.email = user.email;
			state.user.roleId = user.role_id;
			state.user.currency = user.currency;
			state.user.createdBy = user.created_by;
			// state.user.createdTime = user.created_at;
			// state.user.createdDate = user.created_at;
		},
		setRole(state, role) {
			state.user.role = role;
		},
		logout(state) {
			state.user = null;
		},
	},
	actions: {
		logout({ commit }) {
			commit('logout');
		},
	},
	getters: {
		user(state) {
			return state.user;
		},
	},
	plugins: [vuexPersist()],
});
